<template>
  <div>
    <div class="head-item">
      <!--шапка таргета-->
      <div class="head-item-info" v-if="$route.params.hash !== '*'">
        <div class="info-side">
          <div class="item-title">
            <button type="button" id="sidebarCollapse" class="btn">
              <img src="asset/back.svg" alt />
            </button>
            <h3 class>{{ list_name }}</h3>
          </div>

          <span class="short-info">records: {{ total }}</span>
        </div>
        <div class="btn-line">
          <button
            type="button"
            class="btn btn-primary"
            @click="addDialogVisible = true"
          >
            <i class="vik vik-plus"></i>Add records
          </button>
          <button type="button" class="btn btn-primary">
            <i class="vik vik-export"></i>Export
          </button>
        </div>
        <div class="control-side ml-auto">
          <button type="button" class="btn btn-sm btn-icon refresh">
            <i class="vik vik-refresh"></i>
          </button>
        </div>
      </div>
      <!-- end of head -->
      <!-- <div class="filtering">
        <div class="filter-control">
          <div class="btn-line" style="cursor: pointer; margin-left: 15px">
            <button
              type="button"
              class="btn btn-danger"
              v-if="selectedKeywords.length > 0"
              @click="handleRemove(-1)"
            >
              <i class="vik vik-delete"></i>Remove selected
            </button>
          </div>
        </div>
      </div> -->
    </div>
    <div class="pill-control mt-4 mb-3" style="max-width:250px;">
      <el-radio-group class="nav nav-pills unit-group" v-model="view" @change="onViewChange">
        <el-radio-button class="nav-item" value="table" label="table"
          >Table view</el-radio-button
        >
        <el-radio-button class="nav-item" value="raw" label="raw">Raw</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="view == 'table'">
      <div class="table-responsive">
        <el-table :data="records" :total="total" v-loading="loading">
          <el-table-column align="left">
            <template slot="header" slot-scope="scope"> </template>
            <template slot-scope="scope">
              {{ scope.row["value"] }}
            </template>
          </el-table-column>

          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <div class="dual-input-group">
                <div class="search-input">
                  <input
                    type="text"
                    style="border: 2px solid #e3e3e3"
                    class="form-control"
                    placeholder="filter"
                  />
                  <div class="input-icon">
                    <i class="vik vik-search"></i>
                  </div>
                </div>
              </div>
            </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  <i class="vik vik-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click="editKeyword(scope.row.id, scope.row.value)" icon="vik vik-edit">Edit</el-dropdown-item>
                  <el-dropdown-item @click="removeKeyword(scope.row.id)" icon="vik vik-delete">Remove</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
              <!-- <i
                style="cursor: pointer"
                class="vik vik-edit"
                @click="editKeyword(scope.row.id, scope.row.value)"
              ></i>

              <i
                class="vik vik-delete"
                slot="reference"
                style="margin-left: 10px; cursor: pointer"
                @click="removeKeyword(scope.row.id)"
              ></i> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        style="margin-top: 10px"
        background
        layout="prev, pager, next, sizes"
        :total="total"
        :page-sizes="[10, 100, 1000, 10000]"
        :page-size="keywordsPerPage"
        @current-change="changePage"
        :hide-on-single-page="true"
      ></el-pagination>
    </div>
    <div v-else>
      <div style="width: 100%; display: inline-flex">
        <div class="d-form">
          <el-input
            type="textarea"
            placeholder="One record per line"
            style="font-size: 14px"
            v-model="rawContent"
          />
          <el-button
            :loading="loading"
            class="btn btn-success"
            @click="replaceContent"
            icon="vik vik-save"
          >
            Save
          </el-button>
        </div>
      </div>
    </div>

    <el-dialog
      title="Edit value"
      :visible.sync="editDialogVisible"
      class="modalSave"
    >
      <el-form ref="editValueForm" :model="editValueModel">
        <el-form-item
          label="Value"
          prop="new"
          :rules="{
            required: true,
            message: 'Value can not be empty',
            trigger: 'blur',
          }"
        >
          <el-input v-model="editValueModel.new" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="editDialogVisible = false">
          Cancel
        </button>
        <button class="btn btn-success" @click="updateKeyword">
          <i class="vik vik-save"></i>Save
        </button>
      </span>
    </el-dialog>

    <el-dialog title="Add records" :visible.sync="addDialogVisible" class="">
      <el-form
        ref="form"
        label-position="top"
        :model="wordlist"
        @submit.native.prevent
      >
        <div class="" style="width: 100%; display: inline-flex">
          <div class="d-form">
            <el-form-item class="form-group" label="Records" prop="content">
              <el-input
                type="textarea"
                placeholder="One record per line"
                v-model="wordlist.content"
                style="font-size: 14px"
              ></el-input>
            </el-form-item>
          </div>
          <div
            class="d-form"
            style="align-self: center; margin-right: 15px; margin-left: 15px"
          >
            OR
          </div>
          <div class="d-form">
            <el-form-item label="Load from file" class="form-group">
              <div class="border-block">
                <el-upload
                  ref="upload"
                  drag
                  action
                  :auto-upload="true"
                  :file-list="fileList"
                  :before-upload="handleFileUpload"
                  multiple
                >
                  <i class="vik vik-upload"></i>
                  <div class="el-upload__text">
                    Drop file here or <em>click to upload</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    txt files with a size less than 100mb
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="addDialogVisible = false">
          Cancel
        </button>
        <el-button
          :loading="loading"
          class="btn btn-success"
          @click="submitUpload(false)"
          icon="vik vik-save"
        >
          Submit
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as utils from "@/utils.js";
import _ from "lodash";
export default {
  props: ["id"],
  data() {
    return {
      loading: false,
      keywordsPerPage: 10,
      view: "table",
      pageNum: 1,
      records: [],
      rawContent: "",
      created: "",
      total: 0,
      imported: 0,
      list_name: "-",
      percent: 0,
      interval: 0,
      columns: [
        {
          key: "value",
          label: "Value",
          prop: "value",
        },
      ],
      selectedKeywords: [],
      editDialogVisible: false,
      editValueModel: {
        old: "",
        new: "",
        editLineNo: -1,
      },
      addDialogVisible: false,
      file: null,
      fileList: [],
      wordlist: {
        name: "",
        content: "",
      },
    };
  },
  mounted() {
    this.loadListInfo();
    this.loadListContent();
  },

  watch: {
    $route(to, from) {
      this.loadListContent();
      this.loadListInfo();
    },
  },
  computed: {
    downloadURL() {
      return `/api/lists/${this.$route.params.id}/download?q=${this.filters[0].value}`;
    },
  },
  methods: {
    handleRemove(row) {
      utils.sendPost("/api/lists/deleteRecord", { id: row.id }).then((resp) => {
        if (resp.error == null) {
          this.loadListContent();
        } else {
          alert(resp.error);
        }
      });
    },
    editKeyword(line, v) {
      this.editDialogVisible = true;
      this.editValueModel.old = v;
      this.editValueModel.new = v;
      this.editValueModel.editLineNo = line;
    },
    updateKeyword(lineNo) {
      let that = this;
      this.$refs["editValueForm"].validate((valid) => {
        if (valid) {
          utils
            .sendPost(`/api/lists/updatevalue/${this.$route.params.id}/`, {
              line: parseInt(this.editValueModel.editLineNo),
              new: that.editValueModel.new,
            })
            .then((resp) => {
              if (resp.status && resp.status == "ok") {
                that.editDialogVisible = false;
                that.$notify.success({
                  title: "Success",
                  message: "Value updated",
                });
                that.loadListContent();
                return;
              } else {
                that.$notify.error({
                  title: "Error",
                  message: resp.error,
                });
              }
            })
            .catch(function (e) {
              that.$notify.error({
                title: "Error",
                message: e,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    removeKeyword(v) {
      let that = this;
      utils
        .sendPost(`/api/lists/removevalue/${this.$route.params.id}/`, {
          line: parseInt(v),
        })
        .then((resp) => {
          that.$notify.success({
            title: "Success",
            message: "Value deleted",
          });
          that.loadListContent();
          return;
        })
        .catch(function (e) {
          that.$notify.error({
            title: "Error",
            message: e,
          });
        });
    },
    loadListInfo() {
      let that = this;
      fetch("/api/lists/" + this.$route.params.id + "/info")
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          response.json().then(function (data) {
            that.list_name = data.info[0].list_name;
            //that.total = parseInt(data.info[0].total);
            that.imported = parseInt(data.info[0].imported);
            if (data.info[0].total != data.info[0].imported) {
              setTimeout(that.loadListInfo, 1000);
            }
          });
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
    },
    loadListContent() {
      const that = this;
      let loadAll = this.view != "table";
      fetch(
        `/api/lists/${this.$route.params.id}/content/${this.pageNum}/${this.keywordsPerPage}/?q=&all=${loadAll}`
      )
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          response.json().then(function (data) {
            if (that.view == "table") {
              that.records = data.records;
              that.total = parseInt(data.total);
            } else {
              that.rawContent = _.join(_.map(data.records, "value"), "\n");
            }
            if (data.records.length == 0 && that.pageNum > 0) {
              that.pageNum--;
              that.loadListContent();
            }
          });
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
    },
    stopUpdates() {
      clearInterval(this.interval);
    },
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.loadListContent();
    },
    replaceContent() {
      let that = this;
      that.loading = true;
      utils
        .sendPost("/api/upload/list/", {
          id: that.$route.params.id,
          name: that.list_name,
          content: that.rawContent,
          replace: true,
        })
        .then((res) => {
          that.loading = false;
          if (res.error) {
            that.$notify.error(res.error);
          }
          that.$notify({
            type: "success",
            title: "Success",
            message: "Records saved",
          });
          that.loadListContent();
        });
    },
    submitUpload() {
      let that = this;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          that.loading = true;
          utils
            .sendPost("/api/upload/list/", {
              id: that.$route.params.id,
              name: that.list_name,
              content: that.wordlist.content,
              replace: false,
            })
            .then((res) => {
              that.loading = false;
              if (res.error) {
                that.$notify.error(res.error);
              }
              that.$notify({
                type: "success",
                title: "Success",
                message: "Records imported",
              });
              that.loadListContent();
              that.addDialogVisible = false;
            });
        } else {
          that.$notify.error({ title: "Error", message: "Fill in the fields" });
          return false;
        }
      });
    },

    handleFileUpload(file) {
      const that = this;
      this.file = file;
      this.file.text().then((data) => {
        that.wordlist.content += data;
      });
      return false;
    },
    onViewChange(v) {
      // load all or limited
      console.log("onViewChange", v);
      this.loadListContent();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/SingleWordlist.vue